export default {
  cloneFromType: {
    survey: 'Опрос',
    template: 'Шаблон',
  },
  createSurvey: 'Создать опрос',
  createTemplate: 'Создать шаблон',
  newSurvey: 'Новый опрос',
  newSurveyFromScratch: 'Новый опрос с нуля',
  newTemplate: 'Новый шаблон',
  newTemplateFromScratch: 'Новый шаблон с нуля',
  source: {
    label: 'Источник',
    arena: 'Arena (.zip)',
    collect: 'Collect (.collect, .collect-backup, .collect-data)',
    odk: 'ODK (.xml)',
  },
  startImport: 'Начать импорт',
  survey: 'Опрос',
  survey_other: 'Опросы',
  template: 'Шаблон',
  template_other: 'Шаблоны',
  error: 'Ошибка создания нового опроса',
  errorMaxSurveysCountExceeded:
    'Ошибка при создании опроса; вы достигли максимального количества опросов, которые можно создать ({{maxSurveysCount}}).',
  options: {
    includeData: 'Включить данные',
  },
}
